import React, { useState } from "react";

const QuoteModal = ({ isOpen, onClose }) => {
    const [orgName, setOrgName] = useState("");
    const [orgEmail, setOrgEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);

    if (!isOpen) return null;

    const isValid = orgName.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(orgEmail);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isValid) return;
        // TODO: send { orgName, orgEmail } to the quote-request endpoint
        setSubmitted(true);
    };

    const handleClose = () => {
        setOrgName("");
        setOrgEmail("");
        setSubmitted(false);
        onClose();
    };

    return (
        <div className="quote-modal-overlay" onClick={handleClose}>
            <div
                className="quote-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="quote-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="quote-modal-header">
                    <h3 id="quote-modal-title" className="quote-modal-title">Ready to Upgrade your workflow</h3>
                    <button className="quote-modal-close" onClick={handleClose} aria-label="Close">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>

                {submitted ? (
                    <p className="quote-modal-sub">
                        Thank you! Our team will get back to you at <strong>{orgEmail}</strong> with a customized quote.
                    </p>
                ) : (
                    <>
                        <p className="quote-modal-sub">
                            Share your details below. Our team will analyze your setup and get back to you with a transparent customized plan.
                        </p>

                        <form onSubmit={handleSubmit}>
                            <label className="quote-modal-label" htmlFor="quote-org-name">
                                Organization Name <span className="quote-required">*</span>
                            </label>
                            <input
                                id="quote-org-name"
                                type="text"
                                className="quote-modal-input"
                                placeholder="Enter the organization name..."
                                value={orgName}
                                onChange={(e) => setOrgName(e.target.value)}
                                autoFocus
                                required
                            />

                            <label className="quote-modal-label" htmlFor="quote-org-email">
                                Organization Email <span className="quote-required">*</span>
                            </label>
                            <input
                                id="quote-org-email"
                                type="email"
                                className="quote-modal-input"
                                placeholder="Enter the organization email..."
                                value={orgEmail}
                                onChange={(e) => setOrgEmail(e.target.value)}
                                required
                            />

                            <button type="submit" className="quote-modal-submit" disabled={!isValid}>
                                Get My Custom Quote
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default QuoteModal;
